var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.breakdownFilters),function(image,field){return _c('span',{staticClass:"badge badge-secondary"},[_vm._v("\n    "+_vm._s(_vm.names[field])+": "+_vm._s(_vm.sprintImage(image))+" "),_c('span',{staticClass:"times",on:{"click":function($event){return _vm.unselect(field)}}},[_vm._v("×")])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0847b964","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/Filters.vue
// module id = g8v8
// module chunks = 1